import React from 'react';
import { useTheme } from '../../styles/ThemeProvider';
import { Icon } from './Icon';

interface ThemeTogglerProps {
  className?: string;
}

export const ThemeToggler: React.FC<ThemeTogglerProps> = ({ className = '' }) => {
  const { mode, toggleMode } = useTheme();

  return (
    <button
      onClick={toggleMode}
      className={`inline-flex items-center justify-center rounded-lg border border-border bg-background hover:bg-accent hover:text-accent-foreground focus:ring-2 focus:ring-offset-2 focus:ring-accent transition-colors h-8 w-8 ${className}`}
      aria-label={`Switch to ${mode === 'light' ? 'dark' : 'light'} mode`}
      title={`Switch to ${mode === 'light' ? 'dark' : 'light'} mode`}
    >
      <Icon
        name={mode === 'light' ? 'moon' : 'sun'}
        size={16}
        className="text-muted-foreground hover:text-foreground transition-colors"
        aria-hidden="true"
      />
    </button>
  );
};